import { type IconType } from "..";

const TransportIcon: IconType = (props) => {
  const fill = props.fill ?? "fill-white";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.5 24.7"
      className={`${props.size}`}
      {...props}
    >
      <path
        className={`${fill}`}
        d="M17.2 11.8h-1.8c-.3 0-.5.2-.5.5s.2.5.5.5h1.8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5Z"
      />
      <path
        className={`${fill}`}
        d="M29.2 12.9v-.7c0-.4-.5-1.8-5.8-2.8l-4-3.2c-1.4-1.1-3.1-1.7-4.9-1.7h-3.2c-1.9 0-3.7.7-5.1 1.9L3.5 8.7h-1c-.9 0-1.7.8-1.7 1.7v1.1l-.6 1.1V14c0 1.6 1.3 2.9 2.9 2.9h.2c.2 1.4 1.4 2.4 2.9 2.4s2.6-1.1 2.9-2.4h11.6c.2 1.4 1.4 2.4 2.9 2.4s2.6-1.1 2.9-2.4h1.1c.9 0 1.7-.8 1.7-1.7v-2.4Zm-23 5.6c-1.1 0-1.9-.9-1.9-1.9s.9-1.9 1.9-1.9 1.9.9 1.9 1.9-.9 1.9-1.9 1.9Zm17.4 0c-1.1 0-1.9-.9-1.9-1.9s.9-1.9 1.9-1.9 1.9.9 1.9 1.9-.9 1.9-1.9 1.9Zm3.9-2.4h-1.1c-.2-1.4-1.4-2.4-2.9-2.4s-2.6 1.1-2.9 2.4H9c-.2-1.4-1.4-2.4-2.9-2.4s-2.6 1.1-2.9 2.4H3c-1.1 0-1.9-.9-1.9-1.9v-1.1l.4-.8H3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H1.7v-.7c0-.4.3-.7.7-.7h1.2c.1 0 .2 0 .3-.1l2.8-2.5c1.2-1.1 2.8-1.7 4.5-1.7h3.2c1.5 0 3.1.5 4.3 1.5l3 2.4h-7.2V6.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v3.2H9.3L10.5 7c.1-.2 0-.5-.2-.7-.2-.1-.5 0-.7.2L8 9.7v.5c0 .1.3.2.4.2H23c4.5.8 5 1.9 5 1.9v.2h-1.3c-.3 0-.5.2-.5.5s.2.5.5.5H28v1.9c0 .4-.3.7-.7.7Z"
      />
    </svg>
  );
};

export default TransportIcon;
